import Swiper, { SwiperOptions, Navigation } from 'swiper';

export function BaseCompositionPageListGallery(elm: string) {
  const options: SwiperOptions = {
    modules: [ Navigation ],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 20,
    breakpoints: {
      800: { // 800px or more
        slidesPerView: 4
      },
      400: {
        slidesPerView: 2
      },
      0: {
        slidesPerView: 1
      }
    }
  };

  new Swiper(elm, options);
}